//IMPORTS
import React, { useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { Tooltip } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
//COMPONENTS
import SelectFormVirtualize from 'src/components/ComponentesFormularios/SelectFormVirtualize';
//SERVICES
import { mercadoServices } from 'src/services/apiMercados';
//CONSTANTS
import { GlobalConstants } from 'src/data/GlobalConstants';
//STYLES
import { Colors } from 'src/assets/colors/Colors';
import './styles-mercados.css'
import { modalCRUDService } from 'src/services/modalCRUDService';


const FormCRUDClienteMercado = ({properties}) => {
    const { data, cliente, getData}  = properties;
    const dispatch = useDispatch();
    const generalServices = useSelector(state => state.generalServices);
    const [selectInfo, setSelectInfo] = useState(generalServices.arrSelects)
    const methods = useForm({
        defaultValues: {
            ...data
        }
    });

    const { control, handleSubmit } = methods;

    const onSubmit = async (datos) => {
        try {
            const dataMercados = getDataChange(datos, data);

            if(dataMercados.length === 0) {
                dispatch({ type: 'setAlert', alert: { type: GlobalConstants.alertWarning, message: 'No se han realizado cambios' }})
                modalCRUDService.clear();
                return;
            }

            const response = await mercadoServices.setClienteMercados(dataMercados);

            const { status, msg } = response;

            if(status){
                getData();
                dispatch({ type: 'setAlert', alert: { type: GlobalConstants.alertSuccess, message: msg }})
                modalCRUDService.clear();
            }

        } catch (error) {
            dispatch({ type: 'setAlert', alert: { type: GlobalConstants.alertError, message: error.toString() }})
        }
    }

    const onErrorSubmit = (errors) => {}

    //* Se obtiene en un array los mercados que se han cambiado
    const getDataChange = (newData, oldData) => {
        const data = [];

        for(const category in newData){
            const newCategory = newData[category];
            const oldCategory = oldData[category];

            if(newCategory && oldCategory){
                if(newCategory.id !== oldCategory){
                    data.push({
                        idCategoria: category,
                        idMercadoAfter: newData[category].id,
                        idMercadoBefore: oldData[category],
                        nbAgenteComercial: cliente.nbAgenteComercial,
                        idERP: cliente.idERP,
                        ac: 'A'
                    })
                }
            }
            if(newCategory && !oldCategory){
                data.push({
                    idCategoria: category,
                    idMercadoAfter: newData[category].id,
                    idMercadoBefore: null,
                    nbAgenteComercial: cliente.nbAgenteComercial,
                    idERP: cliente.idERP,
                    ac: 'C'
                })
            }
            if(!newCategory && oldCategory){
                data.push({
                    idCategoria: category,
                    idMercadoAfter: null,
                    idMercadoBefore: oldData[category],
                    nbAgenteComercial: cliente.nbAgenteComercial,
                    idERP: cliente.idERP,
                    ac: 'E'
                })
            }
        }

        return data;
    }
  return (
    <FormProvider {...methods}>
        <div className='d-flex justify-content-center boxShadow borderRadius4 mx-5 py-3 w-auto' style={{backgroundColor: Colors.COLOR_CELL_ERROR}}>
            <p style={{margin: 0, fontWeight: 'bold', textAlign: 'center', fontSize: '16px'}}>Cada edición realizada en las relaciones cliente - mercado generan una solicitud de actualización hacia el sistema CRM.</p>
        </div>
        <div className='d-flex align-items-center justify-content-between mx-4 mt-1'>
            <table style={{ width: '70%', marginTop: '10px', marginBottom: '10px' }} className=''>
                <thead>
                    <tr style={{ fontWeight: 'bold', color: '#37A6DE' }}>
                        <td>DATOS DEL CLIENTE</td>
                    </tr>
                    <tr style={{ backgroundColor: '#ebebeb', color: '#404040', }}>
                        <td>Agente Comercial</td>
                        <td>Regional</td>
                        <td>Propietario</td>
                        <td>ID Cliente</td>
                        <td>Negocio</td>
                    </tr>
                </thead>
                <tbody>
                    <tr style={{ fontWeight: 'bold' }}>
                        <td>{cliente.nmAgenteComercial}</td>
                        <td>{cliente.nmOficinaVenta}</td>
                        <td>{cliente.nmPropietarios}</td>
                        <td>{cliente.idERP}</td>
                        <td>{cliente.nmNegocio}</td>
                    </tr>
                </tbody>
            </table>

            <Tooltip title="Guardar" aria-label="guardar-cliente-mercado">
                <a className="icon-container-actions d-flex "
                    onClick={handleSubmit(onSubmit, onErrorSubmit)}>
                    <div style={{ backgroundColor: Colors.COLOR_GREEN_DARK }} />
                    <i style={{ color: Colors.COLOR_GREEN_DARK }} className="far fa-save fa-2x" />
                </a>
            </Tooltip>
        </div>
        <div className='input-container'>
            {
                selectInfo.map((item, index) => {
                    return (
                        <div key={index}>
                            <SelectFormVirtualize isMulti={false} inputProps={{ control }} disabled={false} identificador={item.idCategoria} label={item.nmCategoria}
                                options={item.mercados} showId={true} multiple={false} required={false} className={`input-select`}/>
                        </div>
                    )
                })
            }
        </div>
    </FormProvider>
  )
}

export default FormCRUDClienteMercado
